import axios from 'axios';
axios.defaults.baseURL = process.env.REACT_APP_API_URL;


const auth = async (credentials) => {
  try {
    const data = await axios.post('auth', credentials);
    return data;
  } catch (err) {
    return err;
  }
};

const auth_msal = async (account) => {
  try {
    const data = await axios.post('auth/msal', account);
    return data;
  } catch (err) {
    return err;
  }
};

const createUser = async (user) => {
  try {
    const data = await axios.post('public/user', user);
    return data;
  } catch (err) {
    return err;
  }
};

const forgotPassword = async (email) => {
  try {
    const data = await axios.post('auth/send-password-reset-email', email);
    return data;
  } catch (err) {
    return err;
  }
};

const resetPassword = async (password, token) => {
  axios.defaults.headers.common['Authorization'] = token;
  try {
    const data = await axios.post('me/update-password', password);
    return data;
  } catch (err) {
    return err;
  }
};

export { auth, auth_msal, createUser, forgotPassword, resetPassword };
